<template>
  <div class="sns-item">
    <sns-logo-circle :sns-name="type" />
    <div class="sns-info">
      <span>{{ title }}</span>
      <em v-if="isConnection" class="connect-date"
        >연결일 {{ connectionDateComp }}</em
      >
    </div>
    <connect-button
      :text="buttonText"
      :sns-type="type"
      :sns-id="id"
      :is-connection="isConnection"
      @connect="$emit('connect', { ...$event, snsType: type })"
      @disconnect="$emit('disconnect', { ...$event, snsType: type })"
    />
  </div>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import ConnectButton from '@/components/connection/sns/ConnectButton.vue'
  import { computed } from 'vue'
  import { getLocalDate } from '@/common/utils/date'

  const props = defineProps({
    id: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    connectionDate: {
      type: String,
    },
    isConnection: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
  })

  const connectionDateComp = computed(() => {
    if (!props.connectionDate) return ''
    const date = new Date(props.connectionDate)
    return getLocalDate(date)
  })
</script>

<style lang="scss" scoped>
  .sns-item {
    display: flex;
    align-items: center;
    .sns-info {
      margin-left: 16px;
      flex: 1;
      font-size: 16px;
      color: #fff;
      line-height: 24px;
    }
    .connect-date {
      display: block;
      margin-top: 4px;
      font-size: 14px;
      color: #a5a5a5;
      line-height: 20px;
    }
  }
</style>
